<template>
    <s-modal
        :open="open"
        @close="$emit('close')"
        :close="true"
        :title="'Poule ' + (numPoule+1) "
    >
        <div>
            <b>Les joueurs sont :</b>
        <div v-for="joueur in joueurs">
            {{joueur.numero}} : <span v-if="joueur.captainName==''">Invité</span>
                                <span v-if="joueur.captainName!=''"> {{joueur.captainName}}</span>
                                <span v-if="joueur.coequipier1==''"> / Invité</span>
                                <span v-if="joueur.coequipier1!=null && joueur.coequipier1!=''"> / {{joueur.coequipier1}}</span>
                                <span v-if="joueur.coequipier2==''"> / Invité</span>
                                <span v-if="joueur.coequipier2!=null && joueur.coequipier2!=''"> / {{joueur.coequipier2}} c </span>
        </div>
        </div>
    </s-modal>
</template>
<script>
export default {
    props: ["open","numPoule","tournoi"],
    data() {
        return {
            joueurs: []
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.refresh();
            }
            else
                this.joueurs = [];
        }
    },
    mounted() {
       
        this.refresh();
    },
    methods: {
        refresh() {
            var tabsJoueurs = this.tournoi.pools[this.numPoule];
            tabsJoueurs.forEach((indexJoueur,index) => {
                this.joueurs[index] = {
                    numero: null,
                    captainName: null,
                    coequipier1: null,
                    coequipier2: null
                }
                this.joueurs[index].numero = indexJoueur+1;
                this.joueurs[index].captainName = this.tournoi.joueurs[indexJoueur].nom + this.tournoi.joueurs[indexJoueur].prenom;

                var coequipier1 = this.tournoi.joueurs[indexJoueur].coequipier1;
                if (coequipier1!=null) {
                    var idCoequipier1 = this.tournoi.joueurs.findIndex(joueur=>joueur.id === coequipier1);
                     this.joueurs[index].coequipier1 = this.tournoi.joueurs[idCoequipier1].nom + this.tournoi.joueurs[idCoequipier1].prenom;
                }
                var coequipier2 = this.tournoi.joueurs[indexJoueur].coequipier2;
                if (coequipier2!=null) {
                    var idCoequipier2 = this.tournoi.joueurs.findIndex(joueur=>joueur.id === coequipier2);
                     this.joueurs[index].coequipier2 = this.tournoi.joueurs[idCoequipier2].nom + this.tournoi.joueurs[idCoequipier2].prenom;
                }
            })
            
        }
    }
}
</script>